import { ConfManager } from 'yellowfin-ui-lib';

const conf = ConfManager.getInstance();
conf.apiUrl = process.env.VUE_APP_API;
conf.globalHeaders = [
    { key: 'access_token', value: process.env.VUE_APP_ACCESS_TOKEN as string }
];
